export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    // tslint:disable-next-line:only-arrow-functions
    image.onload = function (): void {
      resolve(this as HTMLImageElement);
    };
    image.onerror = reject;
    image.src = src;
  });
}
